// Compute effective lane per game (with carry-over from the previous game) and
// the lane of the next game the athlete still has to do.
export function gameLanes(athlete) {
  const base = athlete.lane != null && athlete.lane !== "" ? String(athlete.lane) : "";
  const byNum = {};
  (athlete.games || []).forEach((g) => { byNum[g.game_number] = g; });

  const perGame = {};
  let prev = base;
  for (const n of [1, 2, 3]) {
    const g = byNum[n];
    const explicit = g && g.lane != null && g.lane !== "" ? String(g.lane) : "";
    const eff = explicit || prev;
    perGame[n] = eff;
    prev = eff;
  }

  // Next game = first game without a recorded time; fall back to the last game.
  let next = perGame[3];
  for (const n of [1, 2, 3]) {
    const g = byNum[n];
    const done = g && g.time_cs != null;
    if (!done) { next = perGame[n]; break; }
  }
  return { perGame, next };
}
